import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { ReservationPriorityComponent } from './reservation-priority.component';
import { ReservationPriorityDetailComponent } from './reservation-priority-detail.component';
import { ReservationPriorityPopupComponent } from './reservation-priority-dialog.component';
import { ReservationPriorityDeletePopupComponent } from './reservation-priority-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class ReservationPriorityResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const reservationPriorityRoute: Routes = [
    {
        path: 'reservation-priority',
        component: ReservationPriorityComponent,
        resolve: {
            'pagingParams': ReservationPriorityResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.reservationPriority.home.title'
        }
    }, {
        path: 'reservation-priority/:id',
        component: ReservationPriorityDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.reservationPriority.home.title'
        }
    }
];

export const reservationPriorityPopupRoute: Routes = [
    {
        path: 'reservation-priority-new',
        component: ReservationPriorityPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.reservationPriority.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'reservation-priority/:id/edit',
        component: ReservationPriorityPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.reservationPriority.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'reservation-priority/:id/delete',
        component: ReservationPriorityDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.reservationPriority.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-priority/reservation-priority.route.ts